import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator
} from "@/components/ui/dropdown-menu";
import { Compass, LogOut, User as UserIcon, Sparkles } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#FAF7F2]/85 border-b border-stone-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <Link to="/dashboard" className="flex items-center gap-2" data-testid="navbar-brand-logo">
          <div className="w-9 h-9 rounded-full bg-[#C85A32] flex items-center justify-center text-white">
            <Compass size={18} strokeWidth={2.4} />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-serif-display text-xl font-bold text-stone-900">WanderLoom</span>
            <span className="font-mono-code text-[10px] uppercase tracking-[0.25em] text-amber-700 mt-0.5">Travel · Journal</span>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          <Link to="/dashboard" className="hidden sm:inline text-sm text-stone-700 hover:text-[#C85A32]" data-testid="navbar-dashboard-link">Dashboard</Link>
          <Link to="/upgrade" className="hidden sm:inline text-sm text-stone-700 hover:text-[#C85A32]" data-testid="navbar-upgrade-link">Upgrade</Link>
          <span className="hidden md:inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 border border-amber-200 text-amber-800 font-mono-code text-xs">
            <Sparkles size={12} /> {user?.plan === "pro" ? "Pro" : "Free"}
          </span>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm" className="rounded-full pl-1 pr-3 gap-2" data-testid="navbar-user-menu">
                <div className="w-8 h-8 rounded-full bg-stone-900 text-white flex items-center justify-center font-mono-code text-xs">
                  {user?.name?.[0]?.toUpperCase() || "?"}
                </div>
                <span className="text-sm hidden sm:inline">{user?.name?.split(" ")[0]}</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <div className="px-2 py-1.5">
                <div className="text-sm font-semibold">{user?.name}</div>
                <div className="text-xs text-stone-500">{user?.email}</div>
              </div>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => navigate("/dashboard")} data-testid="menu-dashboard">
                <UserIcon size={14} className="mr-2" /> Dashboard
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={async () => { await logout(); navigate("/"); }} data-testid="menu-logout">
                <LogOut size={14} className="mr-2" /> Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
